import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ADMIN, ADMIN_RECINTO } from '../../helpers/Constants';
import { useSelector } from 'react-redux';

const LoginGuard = ({ children }) => {
  const { isAuthenticated, user } = useSelector(state => state.auth);

  if (isAuthenticated) {
    if (user?.tipo === ADMIN) return <Redirect to="/admin/recintos" />;
    if (user?.tipo === ADMIN_RECINTO) {
      return <Redirect to={`/admin-recinto/recintos/${user?.idRecinto}`} />;
    }
  }

  return <>{children}</>;
};

LoginGuard.propTypes = {
  children: PropTypes.node
};

export default LoginGuard;
